<template>
  <v-layout row justify-center>
    <v-dialog v-model="topTrafficPagesBoxDialog" persistent max-width="800">
      <v-card>
        <v-card-title>
          <span class="headline mr-4">
            <v-icon class="pl-2">more</v-icon>
            Top Traffic Pages
          </span>
          <v-btn absolute left depressed flat fab small @click="closeModal()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="overflow: auto;">
          <table class="table table-striped table-hover table-condensed table-responsive v-datatable">
            <thead>
            <tr>
              <th>Pages</th>
              <th class="text-xs-center">Estimated traffic</th>
              <th class="text-xs-center" colspan="2">Best Ranking Keyword with Volume</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in topTrafficPages" :key="item.url">
              <td>
                <a :href="item.url.includes('http') ? item.url : 'http://' + item.url" target="_blank" title="item.from_url" class="a-readmore" v-if="item.url"><read-more  more-str="show full URL" :text="item.url" link="#" less-str="hide" :max-chars="75"></read-more></a>
              </td>
              <td class="text-xs-center">{{ item.estimated }}</td>
              <td class="pl-2">{{ item.best_name }}</td>
              <td class="text-xs-center">{{ item.best_volume }}</td>
            </tr>
            </tbody>
            <tfoot></tfoot>
          </table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'TopTrafficPagesBoxModal',
  props: ['topTrafficPagesBoxDialog', 'project', 'engineId'],
  data () {
    return {
      topTrafficPages: {}
    }
  },
  mounted () {
    if (this.project) {
      this.getTopTrafficPages()
    }
  },
  watch: {
    'topTrafficPagesBoxDialog': function () {
      if (this.topTrafficPagesBoxDialog && this.project) {
        this.getTopTrafficPages()
      }
    }
  },
  methods: {
    getTopTrafficPages () {
      if (this.isAdmin || this.$store.state.user.permissions.indexed_pages_box) {
        let params = {
          top: 25,
          engine_id: parseInt(this.engineId)
        }
        this.loading = true
        this.$store.dispatch('GET_TOP_TRAFFIC_PAGES', { projectId: this.project.id, params: params }).then(res => {
          this.topTrafficPages = res.power_pages
          this.loading = false
        }, err => {
          this.loading = false
          console.log('GET_TOP_TRAFFIC_PAGES error', err)
          let errorText = this.$services.getApiError(err)
          if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
        })
      }
    },
    closeModal () {
      this.$parent.$emit('topTrafficPagesBoxDialog', false)
    }
  }
}
</script>

<style scoped>
table {
    background-color: #fff;
    color: rgba(0,0,0,.87);
    border-collapse: collapse;
    width: 100%;
}
table, th, td {
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
  height: 40px;
}
thead {
    display: table-header-group;
    vertical-align: middle;
    border-color: inherit;
}
table thead tr:first-child {
    border-bottom: 1px solid rgba(0,0,0,.12);
}
table thead th {
    color: rgba(0,0,0,.54);
}
table thead th {
    font-weight: 500;
    font-size: 12px;
    -webkit-transition: .3s cubic-bezier(.25,.8,.5,1);
    transition: .3s cubic-bezier(.25,.8,.5,1);
    white-space: nowrap;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
table tbody tr:hover:not(.v-datatable__expand-row) {
    background: #eee;
}
tbody tr:not(:last-child) {
    border-bottom: 1px solid rgba(0,0,0,.12);
}
table.v-table tbody tr {
    -webkit-transition: background .3s cubic-bezier(.25,.8,.5,1);
    transition: background .3s cubic-bezier(.25,.8,.5,1);
    will-change: background;
}
tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
}
table tbody tr td:nth-child(2) {
  min-width: 75px;
}
</style>



// WEBPACK FOOTER //
// src/components/project-boxes/TopTrafficPagesBoxModal.vue